import agenda from "./agenda"
import convenios from "./convenios"
import dias from "./dias"
import especialidades from "./especialidades"
import paciente from "./paciente"
import page from "./page"
import profissionais from "./profissionais"

const api = {
    paciente,
    convenios,
    especialidades,
    dias,
    profissionais,
    agenda,
    page,
}

export default api